import { createApp } from 'vue'
import { initConfig } from '@finn-no/huck-config'
import { setupMessageBus } from './message-bus'
import App from './App.vue'
import { Alert, Button, Card, Expandable, fDeadToggle } from '@fabric-ds/vue'

if (!customElements.get('pf-bbg-seller')) customElements.define('pf-bbg-seller', class extends HTMLElement {
  async connectedCallback() {
    try {
      initConfig(this)
      setupMessageBus()
      this.shadow = this.attachShadow({ mode: 'open' })
      this.shadow.innerHTML = `
        <link href="https://assets.finn.no/pkg/@fabric-ds/css/v1/fabric.min.css" media="all" type="text/css" rel="stylesheet">
        <div id="app"></div>
      `
      createApp(App)
        .use(Alert)
        .use(Button)
        .use(Card)
        .use(Expandable)
        .component(fDeadToggle.name, fDeadToggle)
        .mount(this.shadow.querySelector('#app'))
    } catch (err) {
      console.log('pf-bbg-seller failed', err)
    }
  }
})
